module.exports = __webpack_public_path__ + "static/media/L0Frame.7b145040.png";